import { appPath } from '@featit/shared/addressing/paths';
/**
 * Where creating an organisation starts, and the only place it starts (I-0682, AC-O1, AC-O2).
 *
 * Jay, 2026-09-24: *"to create an additional organisation should be a more sophisticated process only
 * be startable from the global settings page"*. The sidebar links here; nothing outside the flow
 * creates one.
 */
export const ORGANISATIONS_SECTION_ID = 'organisations';

export const ORGANISATION_FLOW_PATH = appPath(`/settings?section=${ORGANISATIONS_SECTION_ID}`);
